import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { BillingEstimateActions } from './billing-estimate.store';
import { BillingPlansHttpClient } from '../billing-plans/billing-plans-http-client';

@Injectable({ providedIn: 'root' })
export class BillingEstimateEffects {
  private readonly billingPlansHttpClient = inject(BillingPlansHttpClient);
  private readonly actions$ = inject(Actions);

  public effect = createEffectFactory(BillingEstimateActions, this.actions$);

  public fetchBillingEstimate$ = this.effect(BillingEstimateActions.fetch, ({ payload }) =>
    this.billingPlansHttpClient.fetchBillingEstimate(payload),
  );
}
